import Divider from "@components/atoms/divider";
import { Typography } from "@mui/material";
import dayjs from "dayjs";

import {
  Container,
  Content,
  DateWrapper,
  Footer,
  FooterWrapper,
  GameCardTypography,
  Header,
  Info,
  LeftSection,
  LocationTypography,
  RightSection,
  Section,
  Wrapper,
} from "./gameInfoCard.styled";
import { ComponentProps } from "./gameInfoCard.type";

import { ReactComponent as PinMap } from "@assets/images/pin-map/map-pin.svg";

const GameInfo = ({
  location,
  startDate,
  teamA,
  teamB,
  rsvp,
  title,
  scoreA,
  scoreB,
  onClick,
}: ComponentProps) => {
  const formatDate = () => {
    const date = new Date(startDate).toISOString();
    const dateObject = dayjs(date);

    const formattedDate = dateObject.format("ddd, D MMM");
    return formattedDate;
  };

  const formatTime = () => {
    const date = new Date(startDate).toISOString();
    const timeObject = dayjs(date);
    const formattedTime = timeObject.format("HH:mm");
    return formattedTime;
  };

  const teamRender = (team: string, score?: number) => {
    return (
      <Info>
        <GameCardTypography>{team}</GameCardTypography>
        <Typography>
          {score === undefined ? "-" : score === 0 ? "0" : score}
        </Typography>
      </Info>
    );
  };
  return (
    <Container onClick={onClick}>
      <Header rsvp={rsvp}>{title}</Header>
      <Content rsvp={rsvp}>
        <Wrapper>
          <LeftSection>
            <>{teamRender(teamA, scoreA)}</>
            <>{teamRender(teamB, scoreB)}</>
          </LeftSection>
          <Section />
          <RightSection>
            <DateWrapper>
              <GameCardTypography>{formatDate()}</GameCardTypography>
              <GameCardTypography> {formatTime()}</GameCardTypography>
            </DateWrapper>
          </RightSection>
        </Wrapper>
        <Footer>
          <Divider orientation="horizontal" />
          <FooterWrapper>
            <PinMap />
            <LocationTypography>{location}</LocationTypography>
          </FooterWrapper>
        </Footer>
      </Content>
    </Container>
  );
};

export default GameInfo;
